/* eslint-disable max-len */
import React from 'react';

interface Props {
  color?: string;
}

export default function LockIcon({ color = '#047A9C' }: Props) {
  return (
    <path
      d="M5,8 L5,7 C5,3.13400675 8.13400675,7.10171439e-16 12,0 C15.8659932,-7.10171439e-16 19,3.13400675 19,7 L19,8 L20,8 C21.1045695,8 22,8.8954305 22,10 L22,21 C22,22.1045695 21.1045695,23 20,23 L4,23 C2.8954305,23 2,22.1045695 2,21 L2,10 C2,8.8954305 2.8954305,8 4,8 L5,8 Z M7,8 L17,8 L17,7 C17,4.23857625 14.7614237,2 12,2 C9.23857625,2 7,4.23857625 7,7 L7,8 Z M13.3500007,16.2679008 C13.9445068,15.8444026 14.3322224,15.1494235 14.3322224,14.3638885 L14.3322224,14.3361113 C14.3322224,13.0459126 13.2863097,12 11.9961111,12 C10.7059125,12 9.65999985,13.0459126 9.65999985,14.3361113 L9.65999985,14.3638885 C9.65999985,15.1528446 10.0510999,15.8504544 10.6500008,16.2734185 L10.6500008,18.5 C10.6500008,18.7761424 10.8738584,19 11.1500008,19 L12.8500007,19 C13.1261431,19 13.3500007,18.7761424 13.3500007,18.5 L13.3500007,16.2679008 Z"
      fill={color}
    />
  );
}
